/*
 * Displays payment information and form from payment provider
 */

import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BaseComponent } from '@components/base/base.component';
import { BaseService } from '@services/base/base.service';
import {
  StripeCardElementOptions,
  StripeElementsOptions
} from '@stripe/stripe-js';
import { StripeCardComponent, StripeService } from 'ngx-stripe';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-payment-form',
  templateUrl: 'payment-form.component.html',
  styleUrls: ['payment-form.component.less']
})
export class PaymentFormComponent
  extends BaseComponent
  implements OnInit, AfterViewInit
{
  @Input() formGroup: FormGroup;
  @Input() formStep: number;
  @ViewChild(StripeCardComponent) card: StripeCardComponent;

  public cardOptions: StripeCardElementOptions;
  public elementsOptions: StripeElementsOptions;
  public isValid = false;

  constructor(
    public baseService: BaseService,
    private stripeService: StripeService
  ) {
    super(baseService);
    this.stripeService.setKey(this.baseService.getEnv().stripeKey);
  }

  ngOnInit(): void {
    this.cardOptions = {
      style: {
        base: {
          color: '#000',
          fontWeight: 500,
          fontFamily: '"Replica", Helvetica, sans-serif',
          fontSize: '15px',
          fontSmoothing: 'antialiased',
          '::placeholder': {
            color: '#989C9E'
          }
        },
        invalid: {
          iconColor: '#ff462a',
          color: '#ff462a'
        }
      },
      hidePostalCode: true
    };

    this.elementsOptions = {
      locale: 'auto'
    };
  }

  ngAfterViewInit(): void {
    // listener if card input changes to update validity
    this.card.change
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(event => (this.isValid = event.complete));
  }
}
